// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__76is3","card-appears":"Card_card-appears__2OT84"};